import React, { Component, Fragment } from 'react';
import { ICriteria } from '../../components/template-configuration/layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { CQAppConstant } from '../../app-constants';
import { CQCombobox, IOption, ISubHeading } from '../../common/cq-inputs';

interface IProps {
    hideSkipBtn?: boolean
    shouldRender: boolean,
    values: any,
    shouldSkipBtn: Function,
    setValueSectionIndex ?:number,
    optionInfo: {
        options: any[];
        subHeading?: ISubHeading[]
    };
    selectedReferenceFields :any,
    layoutFieldsConfigCtrl :any,
    fieldWisePicklistValues :any,
    onFieldChanged :Function,
    renderReferenceFieldsDropDown :Function,
    onOperatorChanged :Function,
    onCompareToTextChanged :Function,
    onCompareFieldChanged :Function,
    onDynamicFieldsChanged :Function,
    addCriteria :Function,
    deleteCriteria :Function,
    onComplexLogicQueryChanged :Function,
    showComplexLogicInput :Function
    shouldRenderAddComplexBtn :boolean,
    shouldDisableFirstElement :boolean
    objectName ?:string
}

class FieldAndOperator extends Component<IProps, any> {

    constructor(props :IProps) {
        super(props);
        this.state = {
            selectedField: []
        }
    }

    /**
     * generated combobox option
     * @param fieldName name of the field
     * @returns dropdown for combobox
     */
    private generateComboBoxOptionsForPicklist = (fieldName: string): IOption[] => {
        const result: IOption[] = [];
        const values = 
            this.props.layoutFieldsConfigCtrl.getPickListValuesFromState(
                this.props.fieldWisePicklistValues, 
                fieldName
            );
        
        values.forEach((value: any, index: number) => {
            result.push({
                id: `${index + 1}`,
                label: value.label,
                value: value.value
            });
        });

        return result
    }

    private filterOperator = (selectedFieldType: string, selectedField: string) => {
        let operators = [...CQAppConstant.INPUT_RULE_OPERATORS];
        selectedFieldType = selectedFieldType && selectedFieldType.toLowerCase()

        if (selectedFieldType !== "number" && selectedFieldType !== "date" && selectedFieldType !== "percentage" && selectedFieldType !== "time") {
            operators = CQAppConstant.INPUT_RULE_OPERATORS
                .filter((operator: { label: string, value: string }, index: number) => (operator.label === 'Exists' || operator.label === 'Is Empty' || operator.label === 'Equal to' || operator.label === 'Not Equal to'));
        }

        if (!selectedFieldType) {
            operators = CQAppConstant.INPUT_RULE_OPERATORS
                .filter((operator: { label: string, value: string }, index: number) => (operator.label === 'Exists' || operator.label === 'Is Empty'));
        }
        if (selectedField.includes("userInfo.Id")) {
            operators = CQAppConstant.INPUT_RULE_OPERATORS
                .filter((operator: { label: string, value: string }, index: number) => (operator.label === 'Exists' || operator.label === 'Is Empty' ||operator.label === 'Equal to' ||operator.label === 'Not Equal to'));
        }

        return operators;
    }

    render() {
        return (
            <Fragment>
                <div className="slds-grid">
                    <h3 className="slds-m-bottom_small slds-size_2-of-12">
                        Rule Filter
                    </h3>
                    {
                        !this.props.hideSkipBtn && (
                            <div className="slds-form-element slds-size_1-of-12">
                                <label className="slds-checkbox_toggle slds-grid">
                                    <input type="checkbox" name="checkbox-toggle-15" value="checkbox-toggle-15" checked={!this.props.shouldRender} onChange={e => this.props.shouldSkipBtn(e, this.props.setValueSectionIndex)} aria-label="fields-and-operator" aria-describedby="checkbox-toggle-15" />
                                    <span id="checkbox-toggle-15" className="slds-checkbox_faux_container" aria-live="assertive">
                                        <span className="slds-checkbox_faux"></span>
                                        <span className="slds-checkbox_on">Conditional</span>
                                        <span className="slds-checkbox_off">Always On</span>
                                    </span>
                                </label>
                            </div>
                        ) 
                    }
                </div>
                {
                    !this.props.shouldRender
                        ?
                        <Fragment>
                            {this.props.values.addedCriterias && this.props.values.addedCriterias.length > 0 && this.props.values.addedCriterias.map((criteria: ICriteria, criteriaIndex: number) => {
                                return (
                                    <div key={criteriaIndex} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                        <div className="slds-col col-sm slds-m-bottom_small">{criteriaIndex + 1}</div>
                                        <div className="slds-col slds-size_3-of-12">
                                            <div className="slds-form-element">
                                                <div className="slds-form-element__control">
                                                    <div className="slds-select_container">
                                                        <select role="select-field" className="slds-select" id="select-01"
                                                            disabled={this.props.shouldDisableFirstElement ? criteriaIndex === 0 : false}
                                                            onChange={e => this.props.onFieldChanged(e, criteriaIndex, this.props.setValueSectionIndex)}
                                                            value={criteria.field}>
                                                            <option value="">Select field</option>
                                                            {
                                                                this.props.optionInfo.subHeading 
                                                                    ? (
                                                                        this.props.optionInfo.subHeading.map((heading) => (
                                                                            <optgroup key= {heading.id} label= {heading.label}>
                                                                                {
                                                                                    this.props.optionInfo.options.map(option => {
                                                                                        if(heading.id === option.type) {
                                                                                            return (
                                                                                                <option key={option.fieldFullName}
                                                                                                    itemType= {heading.id}
                                                                                                    value={option.fieldFullName}>{`${option.fieldLabel} - ${option.fieldFullName}`}
                                                                                                </option>
                                                                                            )
                                                                                        }

                                                                                        return null;
                                                                                    })
                                                                                }
                                                                            </optgroup>
                                                                        ))
                                                                    )
                                                                    : (
                                                                        this.props.optionInfo.options.map((field: any) => {
                                                                            if (field.customAddedField) {
                                                                                return <option key={field.fieldFullName}
                                                                                    value={`${this.props.objectName}-${field.fieldFullName}`}>{`${field.fieldLabel|| field.label} - ${field.fieldFullName}`}
                                                                                </option>
                                                                            } else {
                                                                                const fieldLabel = field.fieldFullName?.replace(/([a-z])([A-Z])/g, '$1 $2')
                                                                                return <option key={field.fieldFullName}
                                                                                    value={field.fieldFullName}>{`${field.fieldLabel ? field.fieldLabel : fieldLabel} - ${field.fieldFullName}`}
                                                                                </option>
                                                                            }
                                                                        })
                                                                    )
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                (CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType) &&
                                                this.props.selectedReferenceFields.length &&
                                                (criteria.operator !== 'Exists' && criteria.operator !== 'IsEmpty') &&
                                                this.props.renderReferenceFieldsDropDown(criteria, criteriaIndex, this.props.setValueSectionIndex)
                                            }
                                        </div>
                                        <div className="slds-col slds-size_2-of-12">
                                            <div className="slds-form-element">
                                                <div className="slds-form-element__control">
                                                    <div className="slds-select_container">
                                                        <select role="select-operator" className="slds-select"
                                                            value={criteria.operator} onChange={e => this.props.onOperatorChanged(e, criteriaIndex, this.props.setValueSectionIndex)}>
                                                            <option value="">Please Select</option>
                                                            {
                                                                this.filterOperator(criteria.selectedFieldType,criteria.field ).map((operator: { label: string, value: string }, index) => {
                                                                    return (<option key={index} value={operator.value}>{operator.label}</option>);
                                                                })

                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="slds-col slds-size_3-of-12" data-testid= 'compare-to' >
                                            {
                                                !criteria.isDynamic && criteria.selectedFieldType !== CQAppConstant.PICKLIST &&
                                                <div className="slds-form-element">
                                                    <div className="slds-form-element__control">
                                                        <input role="input-compareto" id="" disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'} value={criteria.compareTo} aria-label="compare-to-text"
                                                            onChange={e => this.props.onCompareToTextChanged(e.target.value, criteriaIndex, this.props.setValueSectionIndex)}
                                                            placeholder="Placeholder Text" className="slds-input" />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                !criteria.isDynamic && criteria.selectedFieldType === CQAppConstant.PICKLIST &&
                                                <CQCombobox 
                                                    label={{
                                                        label: '',
                                                        placeholder: ''
                                                    }}
                                                    onActionPerformed={(actionType, value) => {
                                                        if(typeof value === 'string') {
                                                            return;
                                                        }
                                                        this.props.onCompareToTextChanged(
                                                            value.length === 0 ? '' : value[0].value, 
                                                            criteriaIndex, 
                                                            this.props.setValueSectionIndex
                                                        )}
                                                    }
                                                    options={this.generateComboBoxOptionsForPicklist(criteria.field)}
                                                    config={{
                                                        variation: 'readonly',
                                                        isDisabled: criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'
                                                    }}
                                                    value={criteria.compareTo}
                                                />
                                            }
                                            {
                                                criteria.isDynamic &&
                                                <div className="slds-form-element">
                                                    <div className="slds-form-element__control">
                                                        <div className="slds-select_container">
                                                            <select role="select-compareto" className="slds-select" id="select-01"
                                                                disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'}
                                                                value={criteria.compareTo}
                                                                onChange={e => this.props.onCompareFieldChanged(e, criteriaIndex, this.props.setValueSectionIndex)}>
                                                                <option value="">Select field</option>
                                                                {
                                                                    this.props.optionInfo.subHeading 
                                                                        ? (
                                                                            this.props.optionInfo.subHeading.map((heading) => (
                                                                                <optgroup key= {heading.id} label= {heading.label}>
                                                                                    {
                                                                                        this.props.optionInfo.options.map(option => {
                                                                                            if(heading.id === option.type) {
                                                                                                return (
                                                                                                    <option key={option.fieldFullName}
                                                                                                        itemType= {heading.id}
                                                                                                        value={option.fieldFullName}>{`${option.fieldLabel} - ${option.fieldFullName}`}
                                                                                                    </option>
                                                                                                )
                                                                                            }

                                                                                            return null;
                                                                                        })
                                                                                    }
                                                                                </optgroup>
                                                                            ))
                                                                        )
                                                                        : (
                                                                            this.props.optionInfo.options.map((field: any) => {
                                                                                if(field.fieldFullName ==="customSettings") return null;
                                                                                if(field.customAddedField && field.fieldType !=="Lookup"){
                                                                                return <option key={field.fieldFullName}
                                                                                    value={`${this.props.objectName}-${field.fieldFullName}`}>{`${field.fieldLabel || field.label} - ${field.fieldFullName}`}
                                                                                    </option>
                                                                                }else{
                                                                                    return <option key={field.fieldFullName}
                                                                                    value={field.fieldFullName}>{`${field.fieldLabel} - ${field.fieldFullName}`}
                                                                                    </option>
                                                                                }
                                                                            })
                                                                        )
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                        <div className="slds-col slds-size_2-of-12">
                                            <div className="slds-grid slds-m-buttom_xx-small">
                                                <label className="slds-checkbox_toggle">
                                                    <input role="toggle-isDynamic" type="checkbox" name="checkbox-toggle-32" value="checkbox-toggle-32"
                                                        aria-describedby="checkbox-toggle-32"
                                                        checked={criteria.isDynamic}
                                                        disabled={criteria.operator === 'Exists' || criteria.operator === 'IsEmpty'}
                                                        onChange={e => this.props.onDynamicFieldsChanged(e, criteriaIndex, this.props.setValueSectionIndex)} />
                                                    <span id="checkbox-toggle-32" className="slds-checkbox_faux_container" aria-live="assertive">
                                                        <span className="slds-checkbox_faux"></span>
                                                        <span className="slds-checkbox_on">Dynamic</span>
                                                        <span className="slds-checkbox_off">Static</span>
                                                    </span>
                                                </label>
                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" role="add-criteria" onClick={() => {
                                                    this.props.addCriteria(this.props.setValueSectionIndex);
                                                }}>
                                                    <i className="cq-icon-add"></i>
                                                </button>
                                                {criteriaIndex !== 0 &&
                                                    <button className="slds-button slds-button_icon slds-button_icon-border-filled" role="delete-criteria" onClick={() => {
                                                        this.props.deleteCriteria(criteriaIndex, this.props.setValueSectionIndex);
                                                    }}>
                                                        <i className="cq-icon-delete"></i>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            
                            {
                                (this.props.shouldRenderAddComplexBtn ? this.props.values.complexLogicVisibility && this.props.values.addedCriterias.length > 1 : this.props.values.addedCriterias.length > 1) &&
                                <div className="slds-grid">
                                    <div className="slds-col slds-size_8-of-12">
                                        <div className="slds-form-element slds-form-element_horizontal">
                                            <label className="slds-form-element__label">Complex Logic</label>
                                            <div className="slds-form-element__control">
                                                <input role="input-complex" type="text" id="" placeholder="Placeholder Text" aria-label="complex-input"
                                                    value={this.props.values.complexLogicQuery} onChange={e => this.props.onComplexLogicQueryChanged(e, this.props.setValueSectionIndex)}
                                                    className="slds-input" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            
                            {
                                this.props.values.addedCriterias && this.props.shouldRenderAddComplexBtn && this.props.values.addedCriterias.length > 1 &&
                                <div className="slds-grid">
                                    <div className="slds-col slds-size_3-of-12">
                                        <button className="slds-button slds-button_outline-brand slds-m-around_small"
                                            onClick={() => this.props.showComplexLogicInput(this.props.setValueSectionIndex)}>{CQAppConstant.ADD_COMPLEX_LOGIC}</button>
                                    </div>
                                </div>
                            }
                        </Fragment>
                        :
                        null
                }

            </Fragment>
        )
    }
}

export default FieldAndOperator;